import React, { Component, Fragment } from 'react';
import { Label, Row, Col, Input, Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class RevenueComparison extends Component {
    constructor(props) {
        super(props);

        const url = this.props.selector != null ? this.props.selector.split('/') : [];
        this.state = {
            clientId: url[0] != null && parseInt(url[0]) > -1 ? parseInt(url[0]) : -1,
            accountNumber: (url[1] != null && url[1] !== '') /*&& String(url[1]).indexOf('.') > -1 */ ? url[1] : -1,
            year: (url[2] != null && url[2] !== '') /*&& String(url[1]).indexOf('.') === -1*/ && parseInt(url[2]) > -1 ? parseInt(url[2]) : -1,
            month: url[3] != null && parseInt(url[3]) > -1 ? parseInt(url[3]) : -1,
            data: [],
            info: [],
            services: [],
            sheetData: [],
            clientList: this.props.filterClients()
        };
        this.headers = [
            { display: 'Name', accessors: ['name'] }
        ];
        this.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
    }

    componentDidMount() {
        this.props.log('RevenueComparison.js/componentDidMount');
        if (this.state.clientId > -1)
            this.onSubmit();
        this.props.filterClientsCallback(() => {
            this.setState({
                clientList: this.props.filterClients()
            })
        });
    }

    onSubmit = () => {
        this.props.log('RevenueComparison.js/onSubmit');
        fetch('/api/reports/RevenueComparison', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
                { key: 'clientId', type: 'int', value: this.state.clientId },
                { key: 'accountNumber', type: 'nvarchar', value: 0 },
                { key: 'year', type: 'int', value: 0 },
                { key: 'month', type: 'int', value: 0 },
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let data = [];
                    let services = [];
                    results.data.forEach(row => {
                        if (data.findIndex(i => i.clientId === parseInt(row.clientId)) === -1) {
                            data.push({ clientId: parseInt(row.clientId), client: row.name, services: [] })
                        }
                        const clientIndex = data.findIndex(i => i.clientId === parseInt(row.clientId));
                        if (data[clientIndex].services.findIndex(i => i.service === row.service) === -1) {
                            data[clientIndex].services.push({ service: row.service, section: row.section, accountNumber: row.accountNumber, revenues: [] })
                        }
                        if (services.findIndex(i => i.accountNumber === row.accountNumber) === -1) {
                            services.push({ service: row.service, section: row.section, accountNumber: row.accountNumber })
                        }
                        const serviceIndex = data[clientIndex].services.findIndex(i => i.service === row.service);
                        const clone = (({ name, clientId, service, section, accountNumber, ...o }) => o)(row)
                        data[clientIndex].services[serviceIndex].revenues.push({ ...clone, year: parseInt(clone.date.substr(0, 4)), month: parseInt(clone.date.substr(5, 2)) });
                    })
                    services.sort((a, b) => a.service.localeCompare(b.service))
                    this.setState({
                        data: data,
                        services: services
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('RevenueComparison.js/getCSVdata');
        let retArray = [];
        let dates = [...new Set([...this.state.data.map(
            client => client.services.map(
                service => service.revenues.map(
                    revenue => revenue.date.substr(0, 7)
                )
            )
        )].flat(2))];
        // client header;
        if (this.state.clientId > 0 && this.state.data[0] != null) {
            retArray.push([this.state.data[0].client]);
            retArray.push(['']);
        }
        // by service header
        if (parseInt(this.state.accountNumber) !== -1 && this.state.data.length > 0) {
            retArray.push(['By Service']);
            retArray.push(['']);

            // by service
            this.state.data.forEach(client => {
                const services = client.services.filter(service => parseInt(this.state.accountNumber) !== 0 ? service.accountNumber === this.state.accountNumber : service);
                if (services.length > 0) {
                    if (this.state.clientId === 0) {
                        retArray.push([client.client]);
                    }
                    retArray.push(['Date', 'Service', 'Hourly Dollars', 'Monthly Minimum Dollars', 'Quarterly Minimum', 'Units', 'Unit Cost', 'Total', 'Memo']);
                }
                retArray.push(['']);
                services.forEach(service => {
                    service.revenues.forEach(row => {
                        retArray.push([
                            this.displayDate(row.date),
                            service.service,
                            row.hourlyDollars != null ? row.hourlyDollars.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }) : '',
                            row.monthlyMinimumDollars != null ? row.monthlyMinimumDollars.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }) : '',
                            row.quarterlyMinimum != null ? row.quarterlyMinimum.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }) : '',
                            row.units,
                            row.unitCost != null ? row.unitCost.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }) : '',
                            row.total != null ? row.total.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }) : '',
                            row.memo
                        ]);
                    })
                    retArray.push(['Total', service.service, '', '', '', '', '', service.revenues.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toLocaleString('en-US', {
                        style: 'currency',
                        currency: 'USD',
                    })]);
                    retArray.push([''])
                })
                retArray.push(['']);
            })
        }
        // by month header
        if (((this.state.year > -1 && this.state.month > -1) || this.state.year === 0 || this.state.month === 0) && this.state.data.length > 0) {
            retArray.push(['By Month']);
            retArray.push(['']);

            // by month
            this.state.data.forEach(client => {
                const clientData = client.services.map(service => service.revenues.map(revenue => { return ({ ...revenue, service: service.service }) }))
                    .flat().filter(row => (this.state.year === row.year && this.state.month === row.month) ||
                        (this.state.year === row.year && this.state.month === 0) ||
                        (this.state.year === 0 && this.state.month === -1))
                    .sort((a, b) => a.service.localeCompare(b.service))
                    .sort((a, b) => a.date.localeCompare(b.date));
                if (clientData.length > 0) {
                    if (this.state.clientId === 0) {
                        retArray.push([client.client]);
                    };
                    retArray.push(['Month', 'Service', 'Monthly Minimum Dollars', 'Per Seat Pricing', 'Special Per Seat Pricing', 'Units', 'Unit Cost', 'Total', 'Memo']);
                    dates.forEach(yearMonth => {
                        clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).forEach(row => {
                            retArray.push([
                                this.displayDate(row.date),
                                row.service,
                                row.monthlyMinimumDollars != null ? row.monthlyMinimumDollars.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }) : '',
                                row.perSeatPricing != null ? row.perSeatPricing.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }) : '',
                                row.specialPerSeatPricing != null ? row.specialPerSeatPricing.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }) : '',
                                row.units,
                                row.unitCost != null ? row.unitCost.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }) : '',
                                row.total != null ? row.total.toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                }) : '',
                                row.memo
                            ]);
                        })
                        if (clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).length > 0) {
                            retArray.push(['Total', this.months[parseInt(yearMonth.substr(5, 2)) - 1] + ' ' + yearMonth.substr(0, 4), '', '', '', '', '', clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).reduce(
                                (prev, cur) => prev + parseFloat(cur.total), 0).toLocaleString('en-US', {
                                    style: 'currency',
                                    currency: 'USD',
                                })]);
                            retArray.push([''])
                        }
                    })
                    retArray.push([''])
                }
            }
            )
        }
        // no results
        if (this.state.data.length === 0) {
            retArray.push(['No Results']);
        }

        // console.log(retArray);
        this.props.passData(retArray, "revenue-comparison");
        return retArray;
    }

    displayDate = (date) => {
        this.props.info('RevenueComparison.js/displayDate (date)', date);
        return (parseInt(date.substr(5, 2)) + '/' + parseInt(date.substr(8, 2)) + '/' + date.substr(2, 2));
    }

    onChange = (e) => {
        this.props.log('RevenueComparison.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        let refresh = false;
        let value = '';
        this.setState((prevState) => {
            let sel = prevState;
            if (sel.clientId > -1 && (e.target.name === 'year' || e.target.name === 'month')) {
                sel[e.target.name] = parseInt(e.target.value);
                if (sel.year === 0) sel.month = -1;
                if (sel.year === -1) sel.month = -1;
                value = sel.clientId + '/' + (parseInt(sel.accountNumber) === -1 ? '' : sel.accountNumber) + '/' + (parseInt(sel.year) === -1 ? '' : sel.year) + '/' + (parseInt(sel.month) === -1 ? '' : sel.month);
            } else if (sel.clientId > -1 && e.target.name === 'accountNumber') {
                sel[e.target.name] = parseInt(e.target.value) === 0 ? parseInt(e.target.value) : e.target.value;
                value = sel.clientId + '/' + (parseInt(sel.accountNumber) === -1 ? '' : sel.accountNumber) + '/' + (parseInt(sel.year) === -1 ? '' : sel.year) + '/' + (parseInt(sel.month) === -1 ? '' : sel.month);
            } else if (e.target.name === 'clientId' && parseInt(e.target.value) > -1) {
                sel[e.target.name] = parseInt(e.target.value);
                refresh = true;
                value = sel.clientId + '/' + (parseInt(sel.accountNumber) === -1 ? '' : sel.accountNumber) + '/' + (parseInt(sel.year) === -1 ? '' : sel.year) + '/' + (parseInt(sel.month) === -1 ? '' : sel.month);
            } else {
                sel[e.target.name] = e.target.value;
                value = '';
                sel.year = -1;
                sel.month = -1;
                sel.accountNumber = -1;
            }
            this.props.changeSelector({ target: { name: '', value: value.replace(/[/]+$/, '') } });
            return sel;
        }, () => {
            if (refresh) {
                this.onSubmit();
            }
            this.getCSVdata();
        });
    }

    displayService = () => {
        this.props.info('RevenueComparison.js/displayService');
        return (
            <Table>
                {this.state.data.map((client, clientIndex) => {
                    const services = client.services.filter(service => parseInt(this.state.accountNumber) !== 0 ? service.accountNumber === this.state.accountNumber : service);
                    return (
                        <Fragment key={clientIndex}>
                            <thead>
                                {services.length > 0 ?
                                    <>{this.state.clientId === 0 ?
                                        <tr>
                                            <th colSpan={9} className='pt-5'><h2>{client.client}</h2></th>
                                        </tr>
                                        : <></>}
                                        <tr>
                                            <th>Date</th>
                                            <th>Service</th>
                                            <th className="text-right">Hourly Dollars</th>
                                            <th className="text-right">Monthly Minimum Dollars</th>
                                            <th className="text-right">Quarterly Minimum</th>
                                            <th className="text-right">Units</th>
                                            <th className="text-right">Unit Cost</th>
                                            <th className="text-right">Total</th>
                                            <th>Memo</th>
                                        </tr></>
                                    : <></>}
                            </thead>
                            <tbody>
                                {services.map((service, serviceIndex) => (
                                    <Fragment key={serviceIndex}>
                                        {service.revenues.map((row, rowIndex) => (
                                            <tr key={rowIndex}>
                                                <td>{this.displayDate(row.date)}</td>
                                                <td>{service.service}</td>
                                                <td className="text-right">{row.hourlyDollars != null ? row.hourlyDollars.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }) : ''}</td>
                                                <td className="text-right">{row.monthlyMinimumDollars != null ? row.monthlyMinimumDollars.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }) : ''}</td>
                                                <td className="text-right">{row.quarterlyMinimum != null ? row.quarterlyMinimum.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }) : ''}</td>
                                                <td className="text-right">{row.units}</td>
                                                <td className="text-right">{row.unitCost != null ? row.unitCost.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }) : ''}</td>
                                                <td className="text-right">{row.total != null ? row.total.toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                }) : ''}</td>
                                                <td>{row.memo}</td>
                                            </tr>
                                        ))}
                                        <tr className="totalRow">
                                            <td className="pb-4"><strong>Total</strong></td>
                                            <td><strong>{service.service}</strong></td>
                                            <td colSpan={5}></td>
                                            <td className="text-right"><strong>{service.revenues.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            })}</strong></td>
                                            <td></td>
                                        </tr>
                                    </Fragment>
                                ))}
                            </tbody>
                        </Fragment>
                    )
                }
                )}
            </Table>
        )
    }

    displayMonth = (dates) => {
        this.props.info('RevenueComparison.js/displayMonth');
        return (
            <Table>
                {this.state.data.map((client, clientIndex) => {
                    const clientData = client.services.map(service => service.revenues.map(revenue => { return ({ ...revenue, service: service.service }) }))
                        .flat().filter(row => (this.state.year === row.year && this.state.month === row.month) ||
                            (this.state.year === row.year && this.state.month === 0) ||
                            (this.state.year === 0 && this.state.month === -1))
                        .sort((a, b) => a.service.localeCompare(b.service))
                        .sort((a, b) => a.date.localeCompare(b.date));
                    if (clientData.length === 0) return (<></>);
                    return (<Fragment key={clientIndex}>
                        <thead>
                            {this.state.clientId === 0 ? <tr>
                                <th colSpan={9} className='pt-5'><h2>{client.client}</h2></th>
                            </tr> : <></>}
                            <tr>
                                <th>Month</th>
                                <th>Service</th>
                                <th className="text-right">Monthly Minimum Dollars</th>
                                <th className="text-right">Per Seat Pricing</th>
                                <th className="text-right">Special Per Seat Pricing</th>
                                <th className="text-right">Units</th>
                                <th className="text-right">Unit Cost</th>
                                <th className="text-right">Total</th>
                                <th>Memo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dates.map((yearMonth, yearMonthIndex) => (
                                <Fragment key={yearMonth + ' ' + yearMonthIndex}>
                                    {clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>{this.displayDate(row.date)}</td>
                                            <td>{row.service}</td>
                                            <td className="text-right">{row.monthlyMinimumDollars != null ? row.monthlyMinimumDollars.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }) : ''}</td>
                                            <td className="text-right">{row.perSeatPricing != null ? row.perSeatPricing.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }) : ''}</td>
                                            <td className="text-right">{row.specialPerSeatPricing != null ? row.specialPerSeatPricing.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }) : ''}</td>
                                            <td className="text-right">{row.units}</td>
                                            <td className="text-right">{row.unitCost != null ? row.unitCost.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }) : ''}</td>
                                            <td className="text-right">{row.total != null ? row.total.toLocaleString('en-US', {
                                                style: 'currency',
                                                currency: 'USD',
                                            }) : ''}</td>
                                            <td>{row.memo}</td>
                                        </tr>
                                    ))
                                    }
                                    {clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).length > 0 ?
                                        <tr className="totalRow">
                                            <td className="pb-4"><strong>Total</strong></td>
                                            <td><strong>{this.months[parseInt(yearMonth.substr(5, 2)) - 1]} {yearMonth.substr(0, 4)}</strong></td>
                                            <td colSpan={5}></td>
                                            <td className="text-right"><strong>{clientData.filter(row => row.year === parseInt(yearMonth.substr(0, 4)) && row.month === parseInt(yearMonth.substr(5, 2))).reduce(
                                                (prev, cur) => prev + parseFloat(cur.total), 0).toLocaleString('en-US', {
                                                    style: 'currency',
                                                    currency: 'USD',
                                                })}</strong></td>
                                            <td></td>
                                        </tr> : <></>}
                                </Fragment>
                            ))}
                        </tbody>
                    </Fragment>
                    )
                }
                )}
            </Table>
        )
    }

    render() {
        this.props.info('CustomerInfoListing.js/render');
        if (this.state.data == null) return (<>No Results</>)
        let dates = [...new Set([...this.state.data.map(
            client => client.services.map(
                service => service.revenues.map(
                    revenue => revenue.date.substr(0, 7)
                )
            )
        )].flat(2))];
        return (
            <>
                <Row className="mb-4">
                    <Col md={12} className="px-1 noPrint">
                        <Label>Company
                            <Input type="select" className="companySelect" name="clientId" value={this.props.isFieldNull(this.state.clientId)} onChange={this.onChange}>
                                <option value="-1">Select</option>
                                <option value="0">All Companies</option>
                                {this.state.clientList.map(client => (
                                    <option key={client.id} value={this.props.isFieldNull(client.id)}>{client.client}</option>
                                ))}
                            </Input>
                        </Label>
                        {this.state.clientId > -1 ?
                            <Label className="ml-2">Service
                                <Input type="select" name="accountNumber" value={this.props.isFieldNull(this.state.accountNumber)} onChange={this.onChange}>
                                    <option value="-1">Select</option>
                                    <option value="0">All Services</option>
                                    {this.state.services.map((service, serviceIndex) => (
                                        <option key={serviceIndex} value={this.props.isFieldNull(service.accountNumber)}>{service.service}</option>
                                    ))}
                                </Input>
                            </Label>
                            : <></>}
                        {this.state.clientId > -1 ?
                            <Label className="ml-2">Year
                                <Input type="select" name="year" value={this.props.isFieldNull(this.state.year)} onChange={this.onChange}>
                                    <option value="-1">Select</option>
                                    <option value="0">All Dates</option>
                                    {dates.length > 0 ? [...new Set(dates.map(date => date.substr(0, 4)))].map(year => (
                                        <option key={year} value={this.props.isFieldNull(year)}>{year}</option>
                                    )) : <></>}
                                </Input>
                            </Label>
                            : <></>}
                        {this.state.year > 0 ?
                            <Label className="ml-2">Month
                                <Input type="select" name="month" value={this.props.isFieldNull(this.state.month)} onChange={this.onChange}>
                                    <option value="-1">Select</option>
                                    <option value="0">All Months</option>
                                    {dates.length > 0 ? [...new Set(dates.filter(date => parseInt(date.substr(0, 4)) === this.state.year).map(date => parseInt(date.substr(5, 2))))].sort((a, b) => parseInt(a) - parseInt(b)).map(month => (
                                        <option key={month} value={this.props.isFieldNull(month)}>{this.months[month - 1]}</option>
                                    )) : <></>}
                                </Input>
                            </Label>
                            : <></>}
                    </Col>
                </Row>
                {this.state.clientId > 0 && this.state.data[0] != null ? <h2>{this.state.data[0].client}</h2> : ''}
                {parseInt(this.state.accountNumber) !== -1 && this.state.data.length > 0 ? <><h1 className="pt-5">By Service</h1>{this.displayService()}</> : <></>}
                {((this.state.year > -1 && this.state.month > -1) || this.state.year === 0 || this.state.month === 0) && this.state.data.length > 0 ? <><h1 className="pt-5">By Month</h1>{this.displayMonth(dates)}</> : <></>}
                {this.state.data.length === 0 ? <>No Results</> : <></>}
            </>
        );

    }
}

export default RevenueComparison;
